// 🛡 A product's own floor (user 2026-10-15): minimum profit per sale (MAD) for this product everywhere — Jumia,
// Marjane, Auto-Pilot, new copies, manual price changes. Beats every global rule. Empty = global rules.
// Same value as Inventory → 🛡 panel and Auto-Pilot → Own floors (PUT /inventory/min-profit/:groupId).
import { FC, useEffect, useState } from 'react';
import axios from 'axios';
import { urls } from '../../dispatch/urls';

export const saveOwnFloor = async (groupId: string, value: number | null, token: string) => {
  await axios.put(`${urls.baseUrlRestApi}/inventory/min-profit/${groupId}`, { minProfit: value }, { headers: { 'x-auth-token': token } });
  window.dispatchEvent(new Event('own-floor-changed'));
};

export const OwnFloorField: FC<{ groupId: string; initial: number | null | undefined; token: string; compact?: boolean }> = ({ groupId, initial, token, compact }) => {
  const [saved, setSaved] = useState<number | null>(initial ?? null);
  const [v, setV] = useState(initial == null ? '' : String(initial));
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState<{ ok: boolean; text: string } | null>(null);
  useEffect(() => { setSaved(initial ?? null); setV(initial == null ? '' : String(initial)); }, [groupId, initial]);
  const next = v.trim() === '' ? null : Number(v);
  const changed = next !== saved && (next === null || Number.isFinite(next));
  const save = async () => {
    setBusy(true); setMsg(null);
    try { await saveOwnFloor(groupId, next, token); setSaved(next); setMsg({ ok: true, text: next == null ? 'Global rules again (Jumia 25, Marjane 40).' : `Saved — listings under ${next} MAD profit are being raised now.` }); }
    catch (e: any) { setMsg({ ok: false, text: e?.response?.data?.error?.message || e.message }); }
    setBusy(false);
  };
  return (
    <div style={{ fontSize: 12 }}>
      {!compact && <div style={{ fontWeight: 700, marginBottom: 2 }}>🛡 Own floor</div>}
      {!compact && <div style={{ fontSize: 11, color: '#6B7280', marginBottom: 6 }}>Minimum profit per sale for this product, everywhere (Jumia, Marjane, Auto-Pilot, manual prices). Beats every global rule. Empty = global rules.</div>}
      <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
        <input type="number" min={0} value={v} placeholder="global" onChange={(e) => setV(e.target.value)}
          style={{ width: 80, minHeight: 32, border: '1px solid #CBD5E1', borderRadius: 8, padding: '0 8px', fontSize: 13 }} />
        <span style={{ color: '#475569' }}>MAD profit</span>
        {changed && <button disabled={busy} onClick={save} style={{ minHeight: 32, padding: '0 12px', borderRadius: 8, border: 'none', background: '#047857', color: '#fff', fontWeight: 700, cursor: 'pointer' }}>{busy ? 'Saving…' : 'Save'}</button>}
      </div>
      {msg && <div style={{ marginTop: 4, color: msg.ok ? '#047857' : '#B91C1C' }}>{msg.text}</div>}
    </div>
  );
};
